import ApiService from '@/services/api.service'

const ClaimList = {

    getAll(parameter){
           const requestData = {
               method: 'get',
               url: "/PatientClaims/",       
               params: {
                 SearchCriteria: parameter.SearchCriteria,
                 PageSize: parameter.PageSize,
                 PageNumber: parameter.PageNumber,  
                 DateFrom: parameter.DateFrom,
                 DateTo: parameter.DateTo,
                 PatientCode:parameter.PatientCode,
                 Status:"All"
               }
             }       
             return ApiService.customRequest(requestData);
       }, 

    getClaim(Id){
        return ApiService.get(`/PatientClaims/${Id}`);
    },

    filter() {
        return ApiService.get('ClaimStatuses/filter')
    },

    listing(parameter) {
        return ApiService.getWithArray('ClaimStatuses', parameter)
    },

    totalListing(parameter) {
        return ApiService.getWithArray('ClaimStatuses/total', parameter)
    },
    checkStatus(ClaimId, BatchNo) {
        return ApiService.get(`ClaimBatches/status/${ClaimId}:${BatchNo}`)
    },
    validate(parameter) {
        return ApiService.getWithArray('ClaimBatches/validation', parameter)
    },
    checkError(parameter) {
        return ApiService.get(`ClaimBatchValidationError/${parameter.clMUID}`)
    },
    getBatchNo(){
        return ApiService.get('/ClaimStatuses/BatchNo');
    },
    getCheckNo(){
        return ApiService.get('/ClaimStatuses/CheckNo');
    },
    getStatus(){
        return ApiService.get('/ClaimStatuses/Status');
    },
    getInsurances(){
      return ApiService.get('/Insurances');   
    },
    getProviders(){
      return ApiService.get('/Doctors');   
    },
    ValidateAndGetStatus(BatchId){
        return ApiService.get(`/ClaimBatches/validation/?BatchId=${BatchId}`);   
    },

    getClaimError(CLMUID){
        return ApiService.get(`/ClaimBatchValidationError/${CLMUID}`);       
    },

    GetVisitDiagnosisCodes(PatientCode){
        //&ServiceDate=${ServiceDate}
        return ApiService.get(`/DiagnosisICD10Providers/VisitDiagnosisCodes?PatientCode=${PatientCode}`);       
    }
}

export default ClaimList;